// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useAuth } from './AuthContext';
// import { postCookieConsent } from '../api/api';


// const STORAGE_KEY = 'mailora_cookie_consent_v1';
// const API_URL = process.env.REACT_APP_API_URL;

// /* Отправка согласия на бэк.
//    Для гостя — без авторизации (сессионно, по возможности).
//    Для авторизованного — с токеном. */
// async function sendConsentToBackend(payload, token) {
//   if (!API_URL) return;
//   try {
//     await fetch(`${API_URL}/api/consent/cookie`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         ...(token ? { Authorization: `Bearer ${token}` } : {}),
//       },
//       credentials: 'include',
//       body: JSON.stringify(payload),
//     });
//   } catch (e) {
//     // тихо игнорируем — согласие всё равно уже сохранено локально
//   }
// }

// export default function CookieBanner() {
//   const { isAuthenticated, loading, token } = useAuth() || {};
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     if (loading) return;
//     try {
//       const saved = localStorage.getItem(STORAGE_KEY);
//       if (!saved) setVisible(true);
//     } catch {
//       setVisible(true);
//     }
//   }, [loading]);

//   const accept = async () => {
//     const payload = {
//       cookie: true,
//       analytics: true,
//       marketing: false, // у вас маркетинговых cookie нет — оставьте false или уберите
//       acceptedAt: new Date().toISOString(),
//       userAgent: navigator.userAgent,
//     };

//     try {
//       localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
//     } catch {}

//     setVisible(false);

//     // Отправляем в БД. Если пользователь авторизован — с токеном,
//     // иначе бэк может связать по анонимной сессии/куке.
//     await sendConsentToBackend(payload, isAuthenticated ? token : null);
//   };

//   if (!visible) return null;

//   return (
//     <div className="fixed bottom-3 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-1.5rem)] max-w-2xl">
//       <div className="bg-white border border-gray-200 rounded-2xl shadow-lg px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3">
//         <p className="text-[13px] text-gray-600 flex-1 leading-snug">
//           Мы используем cookie для работы сервиса и аналитики. Подробнее — в{' '}
//           <Link to="/cookies" className="text-blue-600 hover:underline">
//             Политике cookie
//           </Link>{' '}
//           и{' '}
//           <Link to="/privacy" className="text-blue-600 hover:underline">
//             Политике конфиденциальности
//           </Link>
//           .
//         </p>
//         <button
//           onClick={accept}
//           className="shrink-0 px-4 py-2 rounded-xl bg-blue-600 text-white text-[13.5px] font-medium hover:bg-blue-700 transition shadow-md"
//         >
//           Принимаю
//         </button>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { postCookieConsent } from '../api/api';

const STORAGE_KEY = 'mailora_cookie_consent_v1';

export default function CookieBanner() {
  const { loading } = useAuth() || {};
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (loading) return;
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, [loading]);

  const accept = async () => {
    const payload = {
      cookie: true,
      analytics: true,
      marketing: false,
      acceptedAt: new Date().toISOString(),
      userAgent: navigator.userAgent,
    };

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch {}

    setVisible(false);

    try {
      await postCookieConsent(payload);
    } catch (e) {
      // тихо игнорируем — согласие уже сохранено локально
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-3 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-1.5rem)] max-w-2xl">
      <div className="bg-white border border-gray-200 rounded-2xl shadow-lg px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-[13px] text-gray-600 flex-1 leading-snug">
          Мы используем cookie для работы сервиса и аналитики. Подробнее — в{' '}
          <Link to="/cookies" className="text-blue-600 hover:underline">
            Политике cookie
          </Link>{' '}
          и{' '}
          <Link to="/privacy" className="text-blue-600 hover:underline">
            Политике конфиденциальности
          </Link>
          .
        </p>
        <button
          onClick={accept}
          className="shrink-0 px-4 py-2 rounded-xl bg-blue-600 text-white text-[13.5px] font-medium hover:bg-blue-700 transition shadow-md"
        >
          Принимаю
        </button>
      </div>
    </div>
  );
}